import { render, staticRenderFns } from "./MoralConfig.vue?vue&type=template&id=2c86e1e4&scoped=true"
import script from "./MoralConfig.vue?vue&type=script&lang=js"
export * from "./MoralConfig.vue?vue&type=script&lang=js"
import style0 from "./MoralConfig.vue?vue&type=style&index=0&id=2c86e1e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c86e1e4",
  null
  
)

export default component.exports